import {
  Favorite,
  FavoriteBorder,
  FavoriteBorderOutlined,
  FavoriteBorderRounded,
  FavoriteOutlined,
  FavoriteRounded,
} from "@mui/icons-material";
import { Button, IconButton } from "@mui/material";
import { useReactToPost } from "../api/reactToPost";
import { useQueryClient } from "@tanstack/react-query";

export default function LikePost({ postId, liked, themeId }) {
  const reactToPostMutation = useReactToPost();
  const queryClient = useQueryClient();
  const handleClick = () => {
    reactToPostMutation.mutate(
      { postId, reaction: liked ? "RAIVA" : "LIKE" },
      {
        onSuccess: (_, variables) => {
          queryClient.invalidateQueries({ queryKey: ["socialMediaFeed"] });
        },
      }
    );
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        {liked ? <Favorite /> : <FavoriteBorder />}
      </IconButton>
    </>
  );
}
